<template>
  <div class="account-pages my-5 pt-5">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-md-8 col-lg-6 col-xl-5">
          <div class="card overflow-hidden">
            <div class="card-body pt-0">
              <div class="p-2 text-center">
                 <div class="user-thumb mb-4 mt-5 text-center">
                    <div class="avatar-md mx-auto">
                        <div class="avatar-title rounded-circle bg-light-primary text-primary h1">
                            <i class="bx bxs-user-circle"></i>
                        </div>
                    </div>
                </div>
                <div v-if="!error">
                    <div class="spinner-border text-primary m-1" role="status">
                        <span class="sr-only">Đang xử lý...</span>
                    </div>
                    <h5 class="font-size-16 mt-3">Đang kết nối SSO...</h5>
                    <p class="text-muted">Vui lòng đợi trong giây lát, hệ thống đang chuyển hướng về Identity System.</p>
                </div>
                
                <div v-else class="alert alert-danger">
                    <h5 class="text-danger"><i class="mdi mdi-block-helper me-2"></i> Lỗi</h5>
                    <p>{{ error }}</p>
                    <router-link to="/" class="btn btn-sm btn-secondary mt-3">Về trang chủ</router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { apiClient } from "@/state/modules/apiClient";

export default {
  page: {
    title: "SSO Login",
    meta: [{ name: "description", content: "SSO Login to Identity System" }]
  },
  data() {
    return {
      error: '',
    };
  },
  mounted() {
    // Delay a bit for UX
    setTimeout(() => {
        this.handleSSO();
    }, 500);
  },
  methods: {
    async handleSSO() {
      const redirectUri = this.$route.query.redirect_uri;
      if (!redirectUri) {
        this.error = "Không tìm thấy tham số 'redirect_uri'. Yêu cầu không hợp lệ.";
        return;
      }

      try {
        const response = await apiClient.post("SSO/generate-token");
        // Check response format based on other stores/apiClient
        // Usually apiClient.post returns response.data directly due to interceptor or wrapper?
        // Let's check apiClient.js wrapper: async post(url, data, config = null) { ... return response.data; }
        // And response structure in Controller is ResultResponse<string>
        
        console.log("SSO Gen Token Response:", response);

        if (response && response.resultCode === "SUCCESS") {
          const token = response.data;
          // Redirect back to Identity System
          // We must ensure redirectUri is safe, but typically server side validates it.
          // Here we trust the query param or we can validate domain.
          
          if (redirectUri.includes("?")) {
             window.location.href = `${redirectUri}&token=${token}`;
          } else {
             window.location.href = `${redirectUri}?token=${token}`;
          }
        } else {
          // Check if response is defined before reading properties
          if (response) {
             this.error = response.message || response.resultString || "Lỗi khi tạo mã SSO.";
          } else {
             this.error = "Không thể kết nối đến máy chủ SSO.";
          }
        }
      } catch (e) {
        this.error = "Có lỗi xảy ra: " + (e.message || e.toString());
        console.error(e);
      }
    },
  },
};
</script>
